// extracted by mini-css-extract-plugin
module.exports = {"languagePreferenceSelector":"styles_languagePreferenceSelector__wmIYD","readInEnglish":"styles_readInEnglish__DG_5t","readInEnglishContent":"styles_readInEnglishContent__M9H_S"};